<template>
  <div
    :id="`${source}_file_attachment_display`"
    class="flex items-center justify-center rounded-lg min-w-[2rem] min-h-[2rem] w-8 h-8 bg_8 border_4 flex-shrink-0"
    :class="{ 'cursor-pointer': isClickable }"
    @click="handleClick"
  >
    <img
      :style="`width: ${iconSize}px; height: ${iconSize}px;`"
      :src="fileIcon"
      :alt="`${attachment?.file_name?.toLowerCase()}_icon`"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import {
  getFileTypeIcon,
  attachmentRendererType,
} from "@/src/constants/attachmentConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  attachment: { type: Object, required: true },
  iconSize: { type: Number, default: 20 },
  type: { type: String, default: attachmentRendererType.UPLOAD },
});

const emit = defineEmits(["download"]);

const fileIcon = computed(() => {
  const extension = props.attachment?.file_name
    ?.split(".")
    .pop()
    ?.toLowerCase();
  return getFileTypeIcon(extension);
});

const isClickable = computed(() => {
  return props.type === attachmentRendererType.PREVIEW;
});

const handleClick = () => {
  if (isClickable.value) {
    emit("download", props.attachment);
  }
};
</script>
